import http from '../http';

export async function fetchAdminCategories() {
  const { data } = await http.get('/api/admin/categories');
  return data.items || [];
}

export async function setCategoryActive(id, isActive) {
  const { data } = await http.patch(`/api/admin/categories/${id}/active`, { isActive });
  return data.item;
}

export async function setSubcategoryActive(categoryId, subId, isActive) {
  const { data } = await http.patch(
    `/api/admin/categories/${categoryId}/subcategories/${subId}/active`,
    { isActive }
  );
  return data.item;
}
